import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons'
import CallDrawerModern from '../CallDrawer/CallDrawerModern'
import TableEmptyState from '../TableComponents/TableEmptyState'
import CallLogTable from './CallLogTable'

import styles from './Table.module.scss'

export default function DataTableView ({
  isAuthenticated,
  rowsList,
  voteStates,
  onRowClick,
  onUpvote,
  onDownvote,
  currentVote,
  selectedRow,
  drawerOpen,
  onCloseDrawer,
  userId,
  dateRangeStart,
  dateRangeEnd,
  containerWidth = '100%'
}) {
  const tableHeadingRef = useRef(null)
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  const handleCloseDrawerInternal = () => {
    onCloseDrawer()
    setTimeout(() => {
      tableHeadingRef.current?.focus()
    }, 0)
  }

  if (!isAuthenticated) return null

  const isPlaceholderData = rowsList && rowsList.length === 1 && rowsList[0].length === 1

  if (!rowsList || rowsList.length === 0 || isPlaceholderData) {
    const noDataMessage = isPlaceholderData ? rowsList[0][0] : t('calls.noCallsFound')

    return (
      <TableEmptyState
        title={t('calls.noCallsFound')}
        message={noDataMessage}
        icon='phone'
        dateRange={dateRangeStart && dateRangeEnd && !isPlaceholderData
          ? {
              start: new Date(dateRangeStart).toLocaleDateString(),
              end: new Date(dateRangeEnd).toLocaleDateString()
            }
          : null}
        renderCustomContent={() => (
          <Typography
            variant='body2'
            color='textSecondary'
            align='center'
            className={styles.emptyStateMessage}
          >
            {t('metrics.expandDateRange')}
            <br />
            {t('metrics.metricsWillAppear')}
          </Typography>
        )}
      />
    )
  }

  const totalPages = Math.ceil(rowsList.length / rowsPerPage)
  const handlePageChange = (event, newPage) => setPage(newPage)
  const handleLimitChange = (newLimit) => {
    setRowsPerPage(newLimit)
    setPage(1)
  }

  const pagedRows = rowsList.slice((page - 1) * rowsPerPage, page * rowsPerPage)

  const renderTableTitle = () => (
    <Box className={styles.titleContainer}>
      <Typography
        variant='h6'
        component='h2'
        className={styles.tableTitle}
        ref={tableHeadingRef}
        tabIndex={-1}
      >
        <Box component='span' className={styles.titleFlex}>
          <FontAwesomeIcon icon={faList} className={styles.titleIcon} />
          {t('calls.title', 'Call Log')}
        </Box>
      </Typography>
    </Box>
  )

  return (
    <div
      className={`mb-4 ${styles.tableContainer}`}
      style={{
        width: containerWidth
      }}
    >
      <Box className={styles.dividerLine} />

      <section className={styles.tableSection}>
        {renderTableTitle()}
        <CallLogTable
          rowsList={pagedRows}
          voteStates={voteStates}
          onRowClick={onRowClick}
          page={page}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          limit={rowsPerPage}
          onLimitChange={handleLimitChange}
          limitOptions={[10, 25, 50]}
        />
      </section>
      {/* Drawer for detailed row info and voting options */}
      <CallDrawerModern
        selectedRow={selectedRow}
        currentVote={currentVote}
        onUpvote={onUpvote}
        onDownvote={onDownvote}
        handleCloseDrawerInternal={handleCloseDrawerInternal}
        drawerOpen={drawerOpen}
        userId={userId}
      />
    </div>
  )
}
